import { gql } from '../../__generated__/gql'

export const SAVE_SONG_SETTINGS_MUTATION = gql(`
  mutation saveSongSettings(
    $songId: Int!
    $charts: [JSON!]
    $lyrics: [JSON!]
    $mixer: JSON
    $songKey: String
    $capo: String
  ) {
    saveSongSettings(
      input: {
        songId: $songId
        charts: $charts
        lyrics: $lyrics
        mixer: $mixer
        songKey: $songKey
        capo: $capo
      }
    ) {
      clientMutationId
    }
  }
`)
